function importBundle(bundleId: string) {
  return import(`/_uplandjs/bundles/${bundleId}`)
}
export function bundleMagic() {
  return importBundle
}
